import { useCompany } from '../lib/companyContext';

/**
 * Dropdown housing every company connected to CVSI. Selecting one scopes the tenant-specific admin
 * pages (Review Queue, Audit Chain, Live Access) to that company's data.
 */
export function CompanySwitcher() {
  const { companies, loading, error, selectedCompanyId, selectCompany } = useCompany();

  return (
    <div className="company-switcher">
      <label htmlFor="company-switcher-select">Company</label>
      <select
        id="company-switcher-select"
        aria-label="Select company"
        value={selectedCompanyId}
        onChange={(e) => selectCompany(e.target.value)}
        disabled={loading || companies.length === 0}
      >
        <option value="">{loading ? 'Loading companies…' : 'Select a company…'}</option>
        {companies.map((c) => (
          <option key={c.tenantId} value={c.tenantId}>
            {c.name}{c.status !== 'active' ? ` (${c.status})` : ''}
          </option>
        ))}
      </select>
      {error && <div className="muted" style={{ fontSize: 11, marginTop: 4 }}>Could not load companies.</div>}
    </div>
  );
}
